import { useBuzz } from "../lib/BuzzProvider";

export function DebugPage() {
  const { client, tick } = useBuzz();
  void tick;

  return (
    <div className="page-pad">
      <div className="page-header">
        <div>
          <h1>Relay debug</h1>
          <p>Low-level status for the same BuzzRelayClient powering Workspace.</p>
        </div>
        <span className={`badge ${client.state === "ready" ? "ok" : "warn"}`}>{client.state}</span>
      </div>
      <div className="panel stack">
        <p>
          <strong>URL:</strong> <span className="mono">{client.relayUrl}</span>
        </p>
        <p>
          <strong>Status:</strong> {client.statusText}
        </p>
        <p>
          <strong>Channels discovered:</strong> {client.channelList().length}
        </p>
        <button
          className="btn"
          type="button"
          disabled={client.state !== "ready"}
          onClick={() => {
            client.selectChannel(client.channelList()[0]?.id ?? null);
          }}
        >
          Resubscribe first channel
        </button>
      </div>
    </div>
  );
}
